import {createIcon, insertPath} from "../utils/iconUtils";
import {createElement} from "../utils/elementUtils";

export const insertBranchSelector = (parent) => {
    const branchSelector = createElement("div", "cat-banner__branch-selector")
    insertBranchIcon(branchSelector)
    const showingStock = createElement("div", "branch-selector-showing-stock", "Showing stock at:")
    branchSelector.appendChild(showingStock)
    const selectedBranchLabel = createElement("div", "branch-selector-selected-branch-label", "Home Branch")
    branchSelector.appendChild(selectedBranchLabel)

    parent.appendChild(branchSelector)
    return branchSelector
}

const insertBranchIcon = (parent) => {
    const branchIcon = createIcon("24", "18")

    insertPath(branchIcon, null, "M22.02 6.18748V16.875C22.0068 16.9873 21.9497 17.0898 21.8612\n" +
        "17.16C21.7726 17.2303 21.6598 17.2627 21.5475 17.25H16.5C16.3568 17.25 16.2194 17.1931 16.1181 17.0918C16.0169 16.9906\n" +
        "15.96 16.8532 15.96 16.71V10.395C15.96 10.2518 15.9031 10.1144 15.8018 10.0131C15.7005 9.91188 15.5632 9.85498 15.42\n" +
        "9.85498H8.57248C8.42856 9.85497 8.29043 9.91162 8.18797 10.0127C8.0855 10.1137 8.02695 10.2511 8.02498\n" +
        "10.395V16.71C8.02503 16.8506 7.97021 16.9858 7.87216 17.0866C7.77411 17.1875 7.64058 17.2461 7.49998\n" +
        "17.25H2.51998C2.37676 17.25 2.23941 17.1931 2.13814 17.0918C2.03687 16.9906 1.97998 16.8532 1.97998\n" +
        "16.71V6.20998C1.99671 6.0993 2.05475 5.99908 2.14243 5.92949C2.23011 5.85991 2.3409 5.82614 2.45248\n" +
        "5.83498H21.5475C21.6594 5.82428 21.7712 5.85736 21.8593 5.92728C21.9474 5.9972 22.005 6.09852 22.02 6.20998")
    insertPath(branchIcon, null, "M23.4075 3.75002H0.592489C0.492822 3.75074 0.3949 3.72386 0.309567\n" +
        "3.67236C0.224233 3.62086 0.154817 3.54675 0.109006 3.45823C0.0631944 3.36972 0.0427748 3.27025 0.0500081\n" +
        "3.17084C0.0572415 3.07143 0.0918456 2.97597 0.149989 2.89502L1.53749 0.975017C1.58787 0.904856 1.65435 0.847805\n" +
        "1.73135 0.808654C1.80835 0.769504 1.89361 0.749395 1.97999 0.750016H22.0275C22.1128 0.749342 22.197 0.76948 22.2728\n" +
        "0.808686C22.3486 0.847891 22.4137 0.904983 22.4625 0.975017L23.85 2.89502C23.9081 2.97597 23.9427 3.07143 23.95\n" +
        "3.17084C23.9572 3.27025 23.9368 3.36972 23.891 3.45823C23.8452 3.54675 23.7757 3.62086 23.6904 3.67236C23.6051 3.72386" +
        "23.5072 3.75074 23.4075 3.75002Z")

    parent.appendChild(branchIcon)
}


// WEBPACK FOOTER //
// ./javascript/product-search-page/branch-selector/insertBranchSelector.js